import type {
    PostalCodeValidationErrorKey,
    PostalCodeValidationErrorResult,
    PostalCodeValidationResult,
    PostalCodeValidationSuccessResult,
} from "./types";

export const successResult = (): PostalCodeValidationSuccessResult => ({
    isValid: true,
});

export const errorResult = (
    message: string,
    key?: PostalCodeValidationErrorKey
): PostalCodeValidationResult => ({
    isValid: false,
    message,
    key,
});

export const isErrorResult = (
    result: PostalCodeValidationResult
): result is PostalCodeValidationErrorResult => {
    return result.isValid === false;
};

export const isSuccessResult = (
    result: PostalCodeValidationResult
): result is PostalCodeValidationSuccessResult => {
    return result.isValid === true;
};
